{
  "Earlier": "이전",
  "newNotification": "새 알림 {newCount}개",
  "newNotifications": "새 알림 {newCount}개",
  "noNotifications": "Adobe 제품, 동료 사용자와의 공동 작업 및 기타 관련 업데이트에 대한 중요한 정보를 받게 됩니다.",
  "noNotificationsTitle": "알림이 여기에 표시됩니다."
}
